// ============================================================
// Google API Configuration
// ============================================================
// 1. Go to https://console.cloud.google.com/
// 2. Create a project and enable "Google Sheets API"
// 3. Create OAuth 2.0 credentials (Web application)
//    - Add your Cloudflare Pages domain as Authorized JavaScript origin
//    - Add http://localhost:5173 for local development
// 4. Set VITE_GOOGLE_CLIENT_ID in .env

export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID

// SPREADSHEET_ID is now stored per-tenant in the D1 `tenants` table.
// It is no longer a frontend config value.

// OAuth scopes required
export const SCOPES = 'openid email profile https://www.googleapis.com/auth/spreadsheets'

